// A helper method to enable the retrieval of the image from the google drive 
// where the copied link will just show a page that contains the image not the actual image

const getDirectImageUrl = (url?: string) => {
  if (!url) return '';
  const match = url.match(/\/d\/(.*?)\/|id=([^&]+)/);
  const fileId = match ? (match[1] || match[2]) : null;

  if (fileId) {
    return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000`;
  }
  
  return url;
};

export default getDirectImageUrl;